module.exports = __webpack_public_path__ + "img/quail.5c98e5ee.png";